webpackJsonp([35783957827783],{

/***/ 238:
/***/ (function(module, exports) {

	/**
	 * https://github.com/gre/bezier-easing
	 * BezierEasing - use bezier curve for transition easing function
	 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	 */
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	var float32ArraySupported = typeof Float32Array === 'function';
	
	function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }
	
	function binarySubdivide (aX, aA, aB, mX1, mX2) {
	  var currentX, currentT, i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}
	
	function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	   var currentSlope = getSlope(aGuessT, mX1, mX2);
	   if (currentSlope === 0.0) {
	     return aGuessT;
	   }
	   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	   aGuessT -= currentX / currentSlope;
	 }
	 return aGuessT;
	}
	
	function LinearEasing (x) {
	  return x;
	}
	
	module.exports = function bezier (mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    throw new Error('bezier x values must be in [0, 1] range');
	  }
	
	  if (mX1 === mY1 && mX2 === mY2) {
	    return LinearEasing;
	  }
	
	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  for (var i = 0; i < kSplineTableSize; ++i) {
	    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	  }
	
	  function getTForX (aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;
	
	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;
	
	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;
	
	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  return function BezierEasing (x) {
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	};


/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bezierEasing = __webpack_require__(238);
	
	var _bezierEasing2 = _interopRequireDefault(_bezierEasing);
	
	var _scrollManager = __webpack_require__(200);
	
	var _scrollManager2 = _interopRequireDefault(_scrollManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_UNIT = 'px';
	var DEFAULT_ANGLE_UNIT = 'deg';
	var ANGLE_PROPERTIES = ['rotate', 'rotateX', 'rotateY', 'rotateZ', 'skew', 'skewX', 'skewY', 'skewZ'];
	
	var EASINGS = {
	  ease: [0.25, 0.1, 0.25, 1.0],
	  easeIn: [0.42, 0.0, 1.00, 1.0],
	  easeOut: [0.00, 0.0, 0.58, 1.0],
	  easeInOut: [0.42, 0.0, 0.58, 1.0],
	  easeInSine: [0.47, 0, 0.745, 0.715],
	  easeOutSine: [0.39, 0.575, 0.565, 1],
	  easeInOutSine: [0.445, 0.05, 0.55, 0.95],
	  easeInQuad: [0.55, 0.085, 0.68, 0.53],
	  easeOutQuad: [0.25, 0.46, 0.45, 0.94],
	  easeInOutQuad: [0.455, 0.03, 0.515, 0.955],
	  easeInCubic: [0.55, 0.055, 0.675, 0.19],
	  easeOutCubic: [0.215, 0.61, 0.355, 1],
	  easeInOutCubic: [0.645, 0.045, 0.355, 1],
	  easeInQuart: [0.895, 0.03, 0.685, 0.22],
	  easeOutQuart: [0.165, 0.84, 0.44, 1],
	  easeInOutQuart: [0.77, 0, 0.175, 1],
	  easeInQuint: [0.755, 0.05, 0.855, 0.06],
	  easeOutQuint: [0.23, 1, 0.32, 1],
	  easeInOutQuint: [0.86, 0, 0.07, 1],
	  easeInExpo: [0.95, 0.05, 0.795, 0.035],
	  easeOutExpo: [0.19, 1, 0.22, 1],
	  easeInOutExpo: [1, 0, 0, 1],
	  easeInCirc: [0.6, 0.04, 0.98, 0.335],
	  easeOutCirc: [0.075, 0.82, 0.165, 1],
	  easeInOutCirc: [0.785, 0.135, 0.15, 0.86]
	};
	
	// Color regexs
	
	// 0 - 199 | 200 - 249 | 250 - 255
	var REGEX_0_255 = '(1?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])';
	// 0.0 - 1.9999...
	var REGEX_0_1 = '([01](\\.\\d+)?)';
	// 00 - FF
	var REGEX_TWO_HEX_DIGITS = '([a-f\\d]{2})';
	
	var HEX_REGEX = new RegExp('^#' + REGEX_TWO_HEX_DIGITS + REGEX_TWO_HEX_DIGITS + REGEX_TWO_HEX_DIGITS + '$', 'i');
	var RGB_REGEX = new RegExp('^rgb\\(' + REGEX_0_255 + ',' + REGEX_0_255 + ',' + REGEX_0_255 + '\\)$', 'i');
	var RGBA_REGEX = new RegExp('^rgba\\(' + REGEX_0_255 + ',' + REGEX_0_255 + ',' + REGEX_0_255 + ',' + REGEX_0_1 + '\\)$', 'i');
	
	var SCROLL_OFFSET = 50;
	
	var RESIZE_DEBOUNCE_TIMEOUT = 150;
	
	// CSS transform map
	var TRANSFORM_MAP = {
	  rotate: function rotate(value, unit) {
	    return 'rotate(' + value + unit + ')';
	  },
	  rotateX: function rotateX(value, unit) {
	    return 'rotateX(' + value + unit + ')';
	  },
	  rotateY: function rotateY(value, unit) {
	    return 'rotateY(' + value + unit + ')';
	  },
	  rotateZ: function rotateZ(value, unit) {
	    return 'rotateZ(' + value + unit + ')';
	  },
	  scale: function scale(value) {
	    return 'scale(' + value + ')';
	  },
	  scaleX: function scaleX(value) {
	    return 'scaleX(' + value + ')';
	  },
	  scaleY: function scaleY(value) {
	    return 'scaleY(' + value + ')';
	  },
	  scaleZ: function scaleZ(value) {
	    return 'scaleZ(' + value + ')';
	  },
	  skew: function skew(value, unit) {
	    return 'skew(' + value + unit + ')';
	  },
	  skewX: function skewX(value, unit) {
	    return 'skewX(' + value + unit + ')';
	  },
	  skewY: function skewY(value, unit) {
	    return 'skewY(' + value + unit + ')';
	  },
	  skewZ: function skewZ(value, unit) {
	    return 'skewZ(' + value + unit + ')';
	  },
	  translateX: function translateX(value, unit) {
	    return 'translateX(' + value + unit + ')';
	  },
	  translateY: function translateY(value, unit) {
	    return 'translateY(' + value + unit + ')';
	  },
	  translateZ: function translateZ(value, unit) {
	    return 'translateZ(' + value + unit + ')';
	  }
	};
	
	// Order of CSS transforms matter
	// so custom order is used
	var ORDER_OF_TRANSFORMS = ['translateX', 'translateY', 'translateZ', 'skew', 'skewX', 'skewY', 'skewZ', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'scaleZ'];
	
	// CSS properties that use color values
	var COLOR_PROPERTIES = ['backgroundColor', 'color', 'borderColor', 'borderTopColor', 'borderBottomColor', 'borderLeftColor', 'borderRightColor'];
	
	var Plx = function (_Component) {
	  _inherits(Plx, _Component);
	
	  function Plx(props) {
	    _classCallCheck(this, Plx);
	
	    var _this = _possibleConstructorReturn(this, (Plx.__proto__ || Object.getPrototypeOf(Plx)).call(this, props));
	
	    var interval = props.interval;
	
	    // Check for universal apps
	
	    if (typeof window !== 'undefined') {
	      // Get scroll manager singleton
	      _this.scrollManager = new _scrollManager2.default(interval);
	    }
	
	    // Binding handlers
	    _this.handleScrollChange = _this.handleScrollChange.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	
	    _this.state = {
	      hasReceivedScrollEvent: false,
	      plxStyle: {},
	      plxStateClasses: ''
	    };
	    return _this;
	  }
	
	  _createClass(Plx, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // Check for universal apps
	      if (typeof window !== 'undefined') {
	        window.addEventListener('plx-scroll', this.handleScrollChange);
	        window.addEventListener('resize', this.handleResize);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.update(this.scrollManager.getWindowScrollTop(), nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('plx-scroll', this.handleScrollChange);
	      window.removeEventListener('resize', this.handleResize);
	
	      clearTimeout(this.resizeDebounceTimeoutID);
	      this.resizeDebounceTimeoutID = null;
	
	      this.scrollManager.destroy();
	      this.scrollManager = null;
	    }
	  }, {
	    key: 'getElementTop',
	    value: function getElementTop(el) {
	      var top = 0;
	      var element = el;
	
	      do {
	        top += element.offsetTop || 0;
	        element = element.offsetParent;
	      } while (element);
	
	      return top;
	    }
	  }, {
	    key: 'getUnit',
	    value: function getUnit(property, unit) {
	      var propertyUnit = unit || DEFAULT_UNIT;
	
	      if (ANGLE_PROPERTIES.indexOf(property) >= 0) {
	        propertyUnit = unit || DEFAULT_ANGLE_UNIT;
	      }
	
	      return propertyUnit;
	    }
	  }, {
	    key: 'hexToObject',
	    value: function hexToObject(hex) {
	      // Convert #abc to #aabbcc
	      var color = hex.length === 4 ? '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3] : hex;
	      var result = HEX_REGEX.exec(color);
	
	      // Safety check, if color is in the wrong format
	      if (!result) {
	        console.log('Plx, ERROR: hex color is not in the right format: "' + hex + '"'); // eslint-disable-line no-console
	        return null;
	      }
	
	      // All color functions are returning { r, g, b, a } object
	      return {
	        r: parseInt(result[1], 16),
	        g: parseInt(result[2], 16),
	        b: parseInt(result[3], 16),
	        a: 1
	      };
	    }
	  }, {
	    key: 'rgbToObject',
	    value: function rgbToObject(rgb) {
	      var isRgba = rgb.toLowerCase().indexOf('rgba') === 0;
	      var color = rgb.replace(/ /g, '');
	      var result = isRgba ? RGBA_REGEX.exec(color) : RGB_REGEX.exec(color);
	
	      // Safety check, if color is in the wrong format
	      if (!result) {
	        console.log('Plx, ERROR: rgb or rgba color is not in the right format: "' + rgb + '"'); // eslint-disable-line
	        return null;
	      }
	
	      // All color functions are returning { r, g, b, a } object
	      return {
	        r: parseInt(result[1], 10),
	        g: parseInt(result[2], 10),
	        b: parseInt(result[3], 10),
	        a: isRgba ? parseFloat(result[4]) : 1
	      };
	    }
	  }, {
	    key: 'colorParallax',
	    value: function colorParallax(scrollPosition, start, duration, startValue, endValue, easing) {
	      var startObject = null;
	      var endObject = null;
	
	      if (startValue[0].toLowerCase() === 'r') {
	        startObject = this.rgbToObject(startValue);
	      } else {
	        startObject = this.hexToObject(startValue);
	      }
	
	      if (endValue[0].toLowerCase() === 'r') {
	        endObject = this.rgbToObject(endValue);
	      } else {
	        endObject = this.hexToObject(endValue);
	      }
	
	      if (startObject && endObject) {
	        var r = this.parallax(scrollPosition, start, duration, startObject.r, endObject.r, easing);
	        var g = this.parallax(scrollPosition, start, duration, startObject.g, endObject.g, easing);
	        var b = this.parallax(scrollPosition, start, duration, startObject.b, endObject.b, easing);
	        var a = this.parallax(scrollPosition, start, duration, startObject.a, endObject.a, easing);
	
	        return 'rgba(' + parseInt(r, 10) + ', ' + parseInt(g, 10) + ', ' + parseInt(b, 10) + ', ' + a + ')';
	      }
	
	      return null;
	    }
	  }, {
	    key: 'parallax',
	    value: function parallax(scrollPosition, start, duration, startValue, endValue, easing) {
	      var min = startValue;
	      var max = endValue;
	      var invert = startValue > endValue;
	
	      // Safety check, if "startValue" is in the wrong format
	      if (typeof startValue !== 'number') {
	        console.log('Plx, ERROR: startValue is not a number, but "' + (typeof endValue === 'undefined' ? 'undefined' : _typeof(endValue)) + '": "' + endValue + '"'); // eslint-disable-line
	        return null;
	      }
	
	      // Safety check, if "endValue" is in the wrong format
	      if (typeof endValue !== 'number') {
	        console.log('Plx, ERROR: endValue is not a number, but "' + (typeof endValue === 'undefined' ? 'undefined' : _typeof(endValue)) + '": "' + endValue + '"'); // eslint-disable-line
	        return null;
	      }
	
	      if (invert) {
	        min = endValue;
	        max = startValue;
	      }
	
	      var percentage = (scrollPosition - start) / duration;
	
	      if (percentage > 1) {
	        percentage = 1;
	      } else if (percentage < 0) {
	        percentage = 0;
	      }
	
	      // Apply easing
	      if (easing) {
	        var easingPropType = typeof easing === 'undefined' ? 'undefined' : _typeof(easing);
	        if (easingPropType === 'object' && easing.length === 4) {
	          percentage = (0, _bezierEasing2.default)(easing[0], easing[1], easing[2], easing[3])(percentage);
	        } else if (easingPropType === 'string' && EASINGS[easing]) {
	          percentage = (0, _bezierEasing2.default)(EASINGS[easing][0], EASINGS[easing][1], EASINGS[easing][2], EASINGS[easing][3])(percentage);
	        } else if (easingPropType === 'function') {
	          percentage = easing(percentage);
	        }
	      }
	
	      var value = percentage * (max - min);
	
	      if (invert) {
	        value = max - value;
	      } else {
	        value += min;
	      }
	
	      return parseFloat(value.toFixed(2));
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var _this2 = this;
	
	      clearTimeout(this.resizeDebounceTimeoutID);
	
	      this.resizeDebounceTimeoutID = setTimeout(function () {
	        _this2.update(_this2.scrollManager.getWindowScrollTop(), _this2.props);
	      }, RESIZE_DEBOUNCE_TIMEOUT);
	    }
	  }, {
	    key: 'handleScrollChange',
	    value: function handleScrollChange(e) {
	      this.update(e.detail.scrollPosition, this.props);
	    }
	  }, {
	    key: 'update',
	    value: function update(scrollPosition, props) {
	      var _this3 = this;
	
	      var parallaxData = props.parallaxData,
	          animateWhenNotInViewport = props.animateWhenNotInViewport;
	      var _state = this.state,
	          hasReceivedScrollEvent = _state.hasReceivedScrollEvent,
	          plxStyle = _state.plxStyle,
	          plxStateClasses = _state.plxStateClasses;
	
	      // Check if element is in viewport
	      // Small offset is added to prevent page jumping
	
	      if (!animateWhenNotInViewport) {
	        var rect = this.element.getBoundingClientRect();
	        var isTopAboveBottomEdge = rect.top < window.innerHeight + SCROLL_OFFSET;
	        var isBottomBellowTopEdge = rect.top + rect.height > -SCROLL_OFFSET;
	
	        if (!isTopAboveBottomEdge || !isBottomBellowTopEdge) {
	          return;
	        }
	      }
	
	      var newState = {};
	      var newStyle = {
	        transform: {}
	      };
	
	      if (!hasReceivedScrollEvent) {
	        newState.hasReceivedScrollEvent = true;
	      }
	
	      var appliedProperties = [];
	      var segments = [];
	      var isInSegment = false;
	      var lastSegmentScrolledBy = null;
	
	      var _loop = function _loop(i) {
	        var _parallaxData$i = parallaxData[i],
	            start = _parallaxData$i.start,
	            duration = _parallaxData$i.duration,
	            offset = _parallaxData$i.offset,
	            properties = _parallaxData$i.properties,
	            easing = _parallaxData$i.easing;
	
	
	        var scrollOffset = offset || 0;
	
	        var startPosition = start;
	        var element = _this3.element;
	
	        if (start === 'top') {
	          startPosition = _this3.getElementTop(_this3.element);
	        } else if (
	        // Percentage start
	        typeof start === 'string' && start.search('%') === start.length - 1 && _this3.isNumber(start.substr(0, start.length - 1))) {
	          var percentageValue = parseFloat(start) / 100;
	          var maxScroll = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
	
	          startPosition = maxScroll * percentageValue;
	        } else if (typeof start === 'string') {
	          element = document.querySelector(start);
	
	          if (!element) {
	            console.log('Plx, ERROR: start selector matches no elements: "' + start + '"'); // eslint-disable-line no-console
	            return {
	              v: void 0
	            };
	          }
	
	          startPosition = _this3.getElementTop(element);
	        }
	
	        startPosition += scrollOffset;
	        var parallaxDuration = duration;
	
	        if (duration === 'height') {
	          parallaxDuration = element.offsetHeight;
	        } else if (
	        // Percentage duration
	        typeof duration === 'string' && duration.search('%') === duration.length - 1 && _this3.isNumber(duration.substr(0, duration.length - 1))) {
	          var _percentageValue = parseFloat(duration) / 100;
	          var _maxScroll = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
	
	          parallaxDuration = _maxScroll * _percentageValue;
	        } else if (typeof duration === 'string') {
	          var durationElement = document.querySelector(duration);
	
	          if (!durationElement) {
	            console.log('Plx, ERROR: duration selector matches no elements: "' + duration + '"'); // eslint-disable-line
	            return {
	              v: void 0
	            };
	          }
	
	          parallaxDuration = _this3.getElementTop(durationElement);
	        }
	
	        var endPosition = startPosition + parallaxDuration;
	
	        // If segment is bellow scroll position skip it
	        if (scrollPosition < startPosition) {
	          return 'break';
	        }
	
	        var isScrolledByStart = scrollPosition >= startPosition;
	
	        if (isScrolledByStart) {
	          lastSegmentScrolledBy = i;
	        }
	
	        // If active segment exists, apply his properties
	        if (scrollPosition >= startPosition && scrollPosition <= endPosition) {
	          isInSegment = true;
	
	          properties.forEach(function (propertyData) {
	            var startValue = propertyData.startValue,
	                endValue = propertyData.endValue,
	                property = propertyData.property,
	                unit = propertyData.unit;
	
	            appliedProperties.push(property);
	
	            // Set default parallax method
	            var parallaxMethod = _this3.parallax.bind(_this3);
	
	            // If property is one of the color properties
	            // Use it's parallax method
	            if (COLOR_PROPERTIES.indexOf(property) > -1) {
	              parallaxMethod = _this3.colorParallax.bind(_this3);
	            }
	
	            // Get new CSS value
	            var value = parallaxMethod(scrollPosition, startPosition, parallaxDuration, startValue, endValue, easing);
	
	            // Get transform function
	            var transformMethod = TRANSFORM_MAP[property];
	
	            if (transformMethod) {
	              // Get CSS unit
	              var propertyUnit = _this3.getUnit(property, unit);
	              // Transforms, apply value to transform function
	              newStyle.transform[property] = transformMethod(value, propertyUnit);
	            } else {
	              // All other properties
	              newStyle[property] = value;
	
	              // Add unit if it is passed
	              if (unit) {
	                newStyle[property] += unit;
	              }
	            }
	          });
	        } else {
	          // Push non active segments above the scroll position to separate array
	          // This way "parallaxDuration" and "startPosition" are not calculated again
	          // and segments bellow scroll position are skipped in the next step
	          segments.push({
	            parallaxDuration: parallaxDuration,
	            properties: properties,
	            startPosition: startPosition
	          });
	        }
	      };
	
	      _loop2: for (var i = 0; i < parallaxData.length; i++) {
	        var _ret = _loop(i);
	
	        switch (_ret) {
	          case 'break':
	            break _loop2;
	
	          default:
	            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	        }
	      }
	
	      // These are only segments that are completly above scroll position
	
	
	      segments.forEach(function (data) {
	        var properties = data.properties,
	            startPosition = data.startPosition,
	            parallaxDuration = data.parallaxDuration,
	            easing = data.easing;
	
	
	        properties.forEach(function (propertyData) {
	          var startValue = propertyData.startValue,
	              endValue = propertyData.endValue,
	              property = propertyData.property,
	              unit = propertyData.unit;
	
	          // Skip propery that was changed for current segment
	
	          if (appliedProperties.indexOf(property) > -1) {
	            return;
	          }
	
	          // Set default parallax method
	          var parallaxMethod = _this3.parallax.bind(_this3);
	
	          // If property is one of the color properties
	          // Use it's parallax method
	          if (COLOR_PROPERTIES.indexOf(property) > -1) {
	            parallaxMethod = _this3.colorParallax.bind(_this3);
	          }
	
	          // Get new CSS value
	          var value = parallaxMethod(scrollPosition, startPosition, parallaxDuration, startValue, endValue, easing);
	
	          // Get transform function
	          var transformMethod = TRANSFORM_MAP[property];
	
	          if (transformMethod) {
	            // Get CSS unit
	            var propertyUnit = _this3.getUnit(property, unit);
	            // Transforms, apply value to transform function
	            newStyle.transform[property] = transformMethod(value, propertyUnit);
	          } else {
	            // All other properties
	            newStyle[property] = value;
	
	            // Add unit if it is passed
	            if (unit) {
	              newStyle[property] += unit;
	            }
	          }
	        });
	      });
	
	      // Sort transforms by ORDER_OF_TRANSFORMS
	      var transformsOrdered = [];
	
	      ORDER_OF_TRANSFORMS.forEach(function (transformKey) {
	        if (newStyle.transform[transformKey]) {
	          transformsOrdered.push(newStyle.transform[transformKey]);
	        }
	      });
	
	      // Concat transforms and add browser prefixes
	      newStyle.transform = transformsOrdered.join(' ');
	      newStyle.WebkitTransform = newStyle.transform;
	      newStyle.MozTransform = newStyle.transform;
	      newStyle.OTransform = newStyle.transform;
	      newStyle.msTransform = newStyle.transform;
	
	      // "Stupid" check if style should be update
	      if (JSON.stringify(plxStyle) !== JSON.stringify(newStyle)) {
	        newState.plxStyle = newStyle;
	      }
	
	      // Adding state class
	      var newPlxStateClasses = null;
	
	      if (lastSegmentScrolledBy === null) {
	        newPlxStateClasses = 'Plx--above';
	      } else if (lastSegmentScrolledBy === parallaxData.length - 1 && !isInSegment) {
	        newPlxStateClasses = 'Plx--bellow';
	      } else if (lastSegmentScrolledBy !== null && isInSegment) {
	        var segmentName = parallaxData[lastSegmentScrolledBy].name || lastSegmentScrolledBy;
	
	        newPlxStateClasses = 'Plx--active Plx--in Plx--in-' + segmentName;
	      } else if (lastSegmentScrolledBy !== null && !isInSegment) {
	        var _segmentName = parallaxData[lastSegmentScrolledBy].name || lastSegmentScrolledBy;
	        var nextSegmentName = parallaxData[lastSegmentScrolledBy + 1].name || lastSegmentScrolledBy;
	
	        newPlxStateClasses = 'Plx--active Plx--between Plx--between-' + _segmentName + '-and-' + nextSegmentName;
	      }
	
	      if (newPlxStateClasses !== plxStateClasses) {
	        newState.plxStateClasses = newPlxStateClasses;
	      }
	
	      if (Object.keys(newState).length) {
	        requestAnimationFrame(function () {
	          _this3.setState(newState);
	        });
	      }
	    }
	  }, {
	    key: 'isNumber',
	    value: function isNumber(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	  }, {
	    key: 'omit',
	    value: function omit(object, keysToOmit) {
	      var result = {};
	
	      Object.keys(object).forEach(function (key) {
	        if (keysToOmit.indexOf(key) === -1) {
	          result[key] = object[key];
	        }
	      });
	
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          style = _props.style;
	      var _state2 = this.state,
	          hasReceivedScrollEvent = _state2.hasReceivedScrollEvent,
	          plxStyle = _state2.plxStyle,
	          plxStateClasses = _state2.plxStateClasses;
	
	
	      var propsToOmit = ['animateWhenNotInViewport', 'children', 'className', 'interval', 'parallaxData', 'style'];
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, this.omit(this.props, propsToOmit), {
	          className: 'Plx ' + plxStateClasses + ' ' + className,
	          style: _extends({}, style, plxStyle, {
	            // TODO think more about how to solve this
	            visibility: hasReceivedScrollEvent ? null : 'hidden'
	          }),
	          ref: function ref(el) {
	            return _this4.element = el;
	          }
	        }),
	        children
	      );
	    }
	  }]);
	
	  return Plx;
	}(_react.Component);
	
	exports.default = Plx;
	
	
	var propertiesItemType = _propTypes2.default.shape({
	  startValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  endValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  property: _propTypes2.default.string.isRequired,
	  unit: _propTypes2.default.string
	});
	
	var parallaxDataType = _propTypes2.default.shape({
	  start: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  duration: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  offset: _propTypes2.default.number,
	  properties: _propTypes2.default.arrayOf(propertiesItemType).isRequired,
	  easing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.func]),
	  name: _propTypes2.default.string
	});
	
	Plx.propTypes = {
	  animateWhenNotInViewport: _propTypes2.default.bool, // eslint-disable-line react/no-unused-prop-types
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  className: _propTypes2.default.string,
	  interval: _propTypes2.default.number,
	  parallaxData: _propTypes2.default.arrayOf(parallaxDataType).isRequired, // eslint-disable-line react/no-unused-prop-types
	  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object]))
	};
	
	Plx.defaultProps = {
	  animateWhenNotInViewport: false,
	  className: '',
	  interval: 16
	};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScrollManager = undefined;
	
	var _Plx = __webpack_require__(475);
	
	var _Plx2 = _interopRequireDefault(_Plx);
	
	var _scrollManager = __webpack_require__(200);
	
	var _scrollManager2 = _interopRequireDefault(_scrollManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Plx2.default;
	exports.ScrollManager = _scrollManager2.default;

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	var instancesCount = 0;
	
	var INTERVAL = 16;
	
	// CustomEvent polyfill
	if (typeof window !== 'undefined' && typeof window.CustomEvent !== 'function') {
	  var _CustomEvent = function _CustomEvent(event) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { bubbles: false, cancelable: false, detail: undefined };
	
	    var evt = document.createEvent('CustomEvent');
	    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	    return evt;
	  };
	
	  _CustomEvent.prototype = window.Event.prototype;
	
	  window.CustomEvent = _CustomEvent;
	}
	
	var ScrollManager = function () {
	  function ScrollManager() {
	    var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INTERVAL;
	
	    _classCallCheck(this, ScrollManager);
	
	    instancesCount++;
	    if (instance) {
	      return instance;
	    }
	
	    instance = this;
	
	    // Bind handlers
	    this.handleInterval = this.handleInterval.bind(this);
	
	    this.intervalID = setInterval(this.handleInterval, interval);
	  }
	
	  _createClass(ScrollManager, [{
	    key: 'destroy',
	    value: function destroy() {
	      instancesCount--;
	
	      if (instancesCount === 0) {
	        // Clear sinfleton instance
	        instance = null;
	        // Remove and reset interval/animationFrame
	        clearInterval(this.intervalID);
	        this.intervalID = null;
	      }
	    }
	  }, {
	    key: 'getWindowScrollTop',
	    value: function getWindowScrollTop() {
	      // Get scroll position, with IE fallback
	      return window.pageYOffset || document.documentElement.scrollTop;
	    }
	  }, {
	    key: 'handleInterval',
	    value: function handleInterval() {
	      var newScrollPosition = this.getWindowScrollTop();
	
	      // Fire the event only when scroll position is changed
	      if (newScrollPosition !== this.scrollPosition) {
	        this.scrollPosition = newScrollPosition;
	
	        var event = new CustomEvent('plx-scroll', {
	          detail: {
	            scrollPosition: newScrollPosition
	          }
	        });
	
	        // Dispatch the event.
	        window.dispatchEvent(event);
	      }
	    }
	  }]);
	
	  return ScrollManager;
	}();
	
	exports.default = ScrollManager;

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = BlogPosts;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _designingMannequin = __webpack_require__(514);
	
	var _designingMannequin2 = _interopRequireDefault(_designingMannequin);
	
	var _componentTheming = __webpack_require__(513);
	
	var _componentTheming2 = _interopRequireDefault(_componentTheming);
	
	var _introducingMannequin = __webpack_require__(515);
	
	var _introducingMannequin2 = _interopRequireDefault(_introducingMannequin);
	
	__webpack_require__(397);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BlogPosts() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'BlogPosts' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Blog Posts'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://lastcallmedia.com/blog/Designing-Mannequin-1.0', title: 'Designing Mannequin 1.0' },
	          _react2.default.createElement('img', { src: _designingMannequin2.default, alt: 'Designing Mannequin 1.0' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'tag' },
	            'Design'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            'Designing Mannequin 1.0'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://lastcallmedia.com/blog/why-component-theming', title: 'Why we\u2019re moving to component theming' },
	          _react2.default.createElement('img', { src: _componentTheming2.default, alt: 'Why we\u2019re moving to component theming' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'tag' },
	            'Coding + Development'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            'Why we\u2019re moving to component theming'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://lastcallmedia.com/blog/introducing-mannequin', title: 'Introducing Mannequin' },
	          _react2.default.createElement('img', { src: _introducingMannequin2.default, alt: 'Introducing Mannequin' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'tag' },
	            'News'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            'Introducing Mannequin'
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Bubble;
	exports.BubbleCluster = BubbleCluster;
	exports.BubbleLayer = BubbleLayer;
	exports.BubbleLayerBoundary = BubbleLayerBoundary;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPlx = __webpack_require__(476);
	
	var _reactPlx2 = _interopRequireDefault(_reactPlx);
	
	var _classnames = __webpack_require__(23);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Bubble(props) {
	  var _cx;
	
	  var _props$size = props.size,
	      size = _props$size === undefined ? 30 : _props$size,
	      _props$thickness = props.thickness,
	      thickness = _props$thickness === undefined ? 1 : _props$thickness,
	      _props$duration = props.duration,
	      duration = _props$duration === undefined ? 3 : _props$duration,
	      _props$blur = props.blur,
	      blur = _props$blur === undefined ? 0 : _props$blur;
	  var left = props.left,
	      right = props.right,
	      top = props.top,
	      bottom = props.bottom,
	      opacity = props.opacity;
	  var _props$className = props.className,
	      className = _props$className === undefined ? '' : _props$className;
	
	  var bubbleClass = (0, _classnames2.default)((_cx = {
	    Bubble: true
	  }, _cx['' + className] = true, _cx));
	  var style = {
	    width: size + 'px',
	    height: size + 'px',
	    borderWidth: thickness,
	    animationDuration: duration + 's',
	    WebkitAnimationDuration: duration + 's',
	    opacity: opacity,
	    left: left,
	    right: right,
	    top: top,
	    bottom: bottom
	  };
	  if (blur > 0) {
	    style.filter = 'blur(' + blur + 'px)';
	  }
	
	  return _react2.default.createElement('b', { className: bubbleClass, style: style });
	}
	Bubble.propTypes = {
	  size: _propTypes2.default.number,
	  thickness: _propTypes2.default.number,
	  blur: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  left: _propTypes2.default.string,
	  right: _propTypes2.default.string,
	  top: _propTypes2.default.string,
	  bottom: _propTypes2.default.string,
	  opacity: _propTypes2.default.number
	};
	
	function BubbleCluster(props) {
	  var children = props.children,
	      _props$duration2 = props.duration,
	      duration = _props$duration2 === undefined ? 3 : _props$duration2,
	      _props$className2 = props.className,
	      className = _props$className2 === undefined ? '' : _props$className2;
	  var left = props.left,
	      right = props.right,
	      top = props.top,
	      bottom = props.bottom;
	
	  var style = {
	    animationDuration: duration + 's',
	    left: left,
	    right: right,
	    top: top,
	    bottom: bottom
	  };
	  return _react2.default.createElement(
	    'b',
	    { className: 'BubbleCluster ' + className, style: style },
	    children
	  );
	}
	BubbleCluster.propTypes = {
	  className: _propTypes2.default.string,
	  duration: _propTypes2.default.number,
	  children: _propTypes2.default.arrayOf(_propTypes2.default.element)
	};
	
	function BubbleLayer(_ref) {
	  var children = _ref.children,
	      _ref$travel = _ref.travel,
	      travel = _ref$travel === undefined ? 100 : _ref$travel;
	
	  return _react2.default.createElement(
	    _reactPlx2.default,
	    {
	      className: 'BubbleLayer',
	      parallaxData: [{
	        start: 'top',
	        duration: 'height',
	        properties: [{
	          startValue: 0,
	          endValue: travel,
	          unit: 'px',
	          property: 'translateY'
	        }]
	      }]
	    },
	    children
	  );
	}
	BubbleLayer.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
	  travel: _propTypes2.default.number
	};
	
	function BubbleLayerBoundary(_ref2) {
	  var children = _ref2.children,
	      className = _ref2.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('BubbleLayerBoundary', className) },
	    children
	  );
	}
	BubbleLayerBoundary.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
	  className: _propTypes2.default.string
	};

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ExtensionSelection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _drupal = __webpack_require__(516);
	
	var _drupal2 = _interopRequireDefault(_drupal);
	
	var _twig = __webpack_require__(519);
	
	var _twig2 = _interopRequireDefault(_twig);
	
	var _html = __webpack_require__(517);
	
	var _html2 = _interopRequireDefault(_html);
	
	__webpack_require__(400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExtensionSelection(_ref) {
	  var className = _ref.className;
	
	  return _react2.default.createElement(
	    'ul',
	    { className: 'ExtensionSelection ' + className },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/extensions/html', className: 'Extension' },
	        _react2.default.createElement(
	          'div',
	          { className: 'img-container' },
	          _react2.default.createElement('img', { src: _html2.default, alt: 'HTML 5 Logo', height: '76', width: '54' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'HTML'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Display Static HTML files as Mannequin Components.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/extensions/twig', className: 'Extension' },
	        _react2.default.createElement(
	          'div',
	          { className: 'img-container' },
	          _react2.default.createElement('img', { src: _twig2.default, alt: 'Twig Logo', height: '85', width: '60' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Twig'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Display Twig Templates as Mannequin Components.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/extensions/drupal', className: 'Extension' },
	        _react2.default.createElement(
	          'div',
	          { className: 'img-container' },
	          _react2.default.createElement('img', { src: _drupal2.default, alt: 'Drupal Logo', height: '43', width: '160' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Drupal'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Display Drupal 8 Twig Templates as Mannequin Components.'
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Footer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Branding = __webpack_require__(18);
	
	var _Branding2 = _interopRequireDefault(_Branding);
	
	var _NewsletterSignup = __webpack_require__(38);
	
	var _NewsletterSignup2 = _interopRequireDefault(_NewsletterSignup);
	
	var _GetSupportButton = __webpack_require__(36);
	
	var _GetSupportButton2 = _interopRequireDefault(_GetSupportButton);
	
	__webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var today = new Date();
	
	function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'page-footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'shift-up-by-half' },
	      _react2.default.createElement(_GetSupportButton2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'inner' },
	      _react2.default.createElement(LearnMore, null),
	      _react2.default.createElement(_NewsletterSignup2.default, null),
	      _react2.default.createElement(_Branding2.default, null),
	      _react2.default.createElement(
	        'small',
	        { className: 'copyright' },
	        'Mannequin \xA9 ',
	        today.getFullYear()
	      )
	    )
	  );
	}
	
	function LearnMore() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'learn-more' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Learn More'
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: '/about', className: 'button dashing expanded' },
	      _react2.default.createElement(
	        'span',
	        { className: 'text' },
	        'About'
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'https://lastcallmedia.com/blog', className: 'button dashing expanded' },
	      _react2.default.createElement(
	        'span',
	        { className: 'text' },
	        'Blog'
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = HomeTopBar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lcmLogo = __webpack_require__(518);
	
	var _lcmLogo2 = _interopRequireDefault(_lcmLogo);
	
	__webpack_require__(402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HomeTopBar() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'HomepageTopBar' },
	    _react2.default.createElement(
	      'a',
	      {
	        className: 'logo',
	        href: 'https://lastcallmedia.com',
	        title: 'Visit Last Call Media'
	      },
	      _react2.default.createElement('img', { src: _lcmLogo2.default, alt: 'Last Call Media Logo' })
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: 'maintained', href: 'https://lastcallmedia.com' },
	      'Maintained by Last Call Media'
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MouseIcon = function (_Component) {
	  _inherits(MouseIcon, _Component);
	
	  function MouseIcon(props) {
	    _classCallCheck(this, MouseIcon);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = { hasScrolled: false
	      // Bind the handleScroll event to this object, otherwise it can become
	      // dereferenced.
	    };_this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	  // Handle any scroll event
	
	
	  MouseIcon.prototype.handleScroll = function handleScroll(e) {
	    this.setState({ hasScrolled: window.scrollY > 0 });
	  };
	  // Lifecycle callback to attach the event listener when the component is mounted.
	
	
	  MouseIcon.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('scroll', this.handleScroll);
	  };
	  // Lifecycle callback to detach the event listener when the component is unmounted.
	
	
	  MouseIcon.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('scroll', this.handleScroll);
	  };
	
	  MouseIcon.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'mouse-icon' + (this.state.hasScrolled ? ' fade-out' : '') },
	      _react2.default.createElement('div', { className: 'wheel' })
	    );
	  };
	
	  return MouseIcon;
	}(_react.Component);
	
	exports.default = MouseIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/component-theming.a064bc33.png";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/designing-mannequin.fedb519e.png";

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/introducing-mannequin.311e1bb8.jpg";

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAACYCAMAAAALKZ2WAAAB0VBMVEVHcEzkTCXkSyPjSyQBAQHbTiXlTSXjTSXTSx7+/v7kTCW9vb29vb3b29sHBwetra319fXkTCXCwsLkTSXkTSbjTCSBgYHhSiG9vb3Nzc24uLjlTSbkSyTjTCTkSSHb29vAwMDoSSbjTCXkTSXkTCXkTCQfExDkTSXjSSTmTSaLi4vkTCWpqanDw8PJycniblBDQ0Pt7e39/f3kTCX5+fnjTCXlTCXnTib9/f3kSyX09PTe3t7kTCTY2NiHh4fMzMz7+/uZmZmnp6fm5ubU1NTT09OBgYG4uLi5ublISEjjTSRiYmLe3t7Q0NCTk5PkTSbr6+vxZSn////xYyjpTifkTCXlTybtUCfr8vTyZinxXyHkSiPr7e7kRx7lTSbrTyfr7/DwXh/nTibxYSTkSB/lYT/r5OLxaS/95tz//v7op5X5vKL3qorv7+/kUizuXyjzeUT/9/TkRh3q0cvu9PboVCfrWSfnUibs8fLnlYDmfWDtXCjlWTTqyL/pu6/q3Nj2mHH828z5tJfla0vnhGvmdlntUif6w6z3poP1jWDorp7ooI30glH++/rybzb+8Orn0MrnkHnr6enr1M770L7949j7z7v81cXycjvxUSjyazG9dHLiAAAAT3RSTlMA9xhNCgPO4RCEefU03haD/qfzvN4mkg15+F/rNzv/+2EKj7ZkYAfuKv3FkvvR4SMoX4WiYWfY5SeI++VZEcZNOcNO/KTQr7jyQz9rhXOE2rPMYQAACF1JREFUeNrtm3lX01gYhy9UC4OOiIVBBMoogDCMnFHct+Ous1aahpbuG0BVAYpqVXbgsI9HUA/Mp500W5N7b+7NTSDnzBx//9hoy2Nekifvm9wCoMn3fjE/iRs/ShtHDoGTfiQtv4Cjx6WXj+QP39uStn8AoFp6dQLQYgkovBTT43cI6L8rvr065xjw+u8AHL7V4ncM6H9yDIDHfgeBuUfg3nU7wNuHijlFAt7XAv0tv/b4bQBzLUeKaVCBR08W80D+4dXFjVMdWmCuYcsO0J/LafZFAEqR97hB2dYAdZ+wANQFAR7DALX53wFb7stv3L7hDPDJn/Ibq885Azwhf6rhMAI8ckwNGXjufDEPTAI7rhZP+uP3AAK8/7OSux3E8/C2FkAHgj+EPx4DFFhKzyEmtdGAt274W245CQR3rp8CJGBuv4HgDgB29vA2MxAAa3t4Q3sJl4E9yg+Ut2+oLpWE3aACH0pv+Augl5eHBsCL34kRCwSuiq8vXFT+Ed6+Jb1Z3QbnL4h/cVV4q/SqlIsd4EBzGHzLt/zHU1/pYOoBOHztSoVjuVIlAC/tBRzLXpsAdAV8jiXgEoBNXXGnePGuJgBAXZlzwLI6AVh+Nu0UMN1YXjwtah37JQZq64sXE3fCMaBbvHJ5LAH7GaIcJAmPqJreoBXeGGc6fW946UPBXhF4xhKQ6zOdARV4RgRWHTSw77UCrBKB7QmngIl2EehKHzTwrQxMu0Rgky9+wMB+WTS+JhFoyW0sQK5fazbBbY3pAwbqzGbRbSzAMdVsp6Umw33AwA+8Yja5q2lNHChwQAEmWmWgFbexACGz4dzGx2jJpsK0qP8lyGwYt0UGn1HznJpdDm82jNu8i9FQgZxXflq2xjOQaGSzCW5LIHs4FH1KzsscDfjxbw4GumQg0rdFpmbtA0eGOchsXU0ysLMMUg0/OmkfON8nAzl5d9Ky2TBu433TSdvArxlINIrZADhdAavGO1OwDVxJGZkN07fl1+0DF8Iw0K3ebUDcFtuwD1wNG5kNgBr4zM9/sg+cC8Nmq1GBiNtiS/YPmrWMkdkwbssu2z4ttjYzRmYT3IbIdHFb9+OjSAp0syEqbVeByEzq1bttaBLJzggl84jZAi4V2Az3bbzObcnpUTTDtKA9W7MKRPo2vduSk6MRHkqcPlEY9GwAN5PyvNZt0dmpiPUr/pii0rPlpVs1SN8W07ltaNAOUDeNKm5DgDq3bS96bQAV0bg191GRmTS/EdKeFe+z1oGq2Tya218Yt2mBhaW8ZSDObBi35XVuK7yL7QPwjAaIcZtWNIUN60Cc2QBoI7sttL4fwHYNEHGbvm8rzNg4SjFmA6ApTuzbktM+3jIQmkZNuS06yeehxFLkhElmw82kercNvUPygpw5pQJqk9hYrr0NXUvp20JwaK3+SphgNpzbaH0b7Yq/kILMpk6jptzGDlxNwT2bRwdE3Bb7ZG8P0Z6tVwfsRlRD6dtoQKVnw5sN47YYpW+jAHOkng3rNi/UtzECJ8YRYJsOyDyTUoCEaVTu27qIfRszkDCNWpxJKcDSNNqvTKOdOiDat1FmUgpQnUY5H85sgtsq0ojbQlFCXjJOo2l1GjXs255tD5EyAcfAbOg0auA2fmqQmHF9dlcp06gHemxZg97+ipDCZ/RJrZqeRg3cxnhzL7WgN1uYbDb2ZwkwMLxieho1cBsjMPNZbzaObDaM24QLhjZeCpCbZzIbxm2+/uX3miyTgdzwCMVszRCwE+3bdgql8zy0M8oTgbsfdWbjOFLPZmUmhYCZcd2J/zlDmEalVCJ9W3YmSZhJYeBmjqFnw99vI8+kMHCN3LMl3MiqHg96v003ky5nScDwHLZn6zM0G/NMCgGZzYZxm/5+W+hTjLiHrGaj3m+DZ1IYuMLUsxVzidy3FdaJQGazmZhJ817eCMhlwnqz7XKkaVR2G3kmjc5+WhyNxSI8DBRg4X82X3wkmy3ejAApM+nTaGF7cn1p0BfLRkpALhweGF9dGYE6qnmuj2Y23BoQHu7booXk0PSz91ORvDfSz3HhFDc+9/zLBNpCqWbDT6Oy25BnCRHMs4RoshCdnXm3PBXJ7K4tzE9YmkbN3W/TQkNPZ2c+F39rOdPTKGa9IttMShy5X6RoPRv7swRi523GbKwzKRGITqPdGCDbswQS0JTZqG5jAFKnUcOZdCcZSkbZgV/oPZvoNmSBBD+1vDE9JJx5DMCJ+YU1laeYzZduxgCRmVTYx2zMN7i0vrNdQKA44NaXlblxLpVBniDA06h04uPXt/GRWHZ08d3MbDSUJAI/fl3dHNY8vKeZDTeTqlBvPiJWV7OjOqBYx4xm1+BptOI0brE0cQ0Ir1RXPoxUIFJH3CMLN3YlNm19W6m6haQMxNURt+rDg11KW2NigBKr+16o7ivDOtKeILDPpNKxa1hHHLAbu+CdYSblI9kwZ/EJAsFtttfTEM2GnUltAolmA+C3eHwfgQN93AfMs1HiTGoZOCCcgm9e95dW6nZigUxrd0nAsQ8CjC+1zeg0qvRttoFCHcfevNXCpJ6tEgvsYFnfhgWKdeR5g5W67G4jAAeQOmpiYDYAWvfSVoBSHeN4WPFXuNdqALzpLgsGA3FGYLGOvBEtHggmytw3Db/OU9fee7krmEibBXLGdSzuWiLYdbn3Zh35W0L1TVWtjQEqVBhmyHVMBNONrVVNp01956PcdYZa3be0Ol5zlTN9Waqurbc2TthRw10LmqmjQXWbqzxCdQOmjSfUMXDFdB2tV9d6HQ2q29lWU+sjHkZSHdvr9u9ba4Tq7kcdjarbDVd3H+toVN1LNeqxu/91xKdSrG46cEB1NKjuzcsea3X8FxIl2SqJ1SDyAAAAAElFTkSuQmCC"

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABOCAYAAACOqiAdAAAABGdBTUEAALGPC/xhBQAABWJJREFUeAHtmtmrjl8Ux7/HPE8ZblBIbkSGzFM6VxJCUcqNUm7lzp1/QLhRKLlAXCCU3MkQ5UYyFHFhCBkzj+d3Plb75z2co/fsd+3nedTe9fSc9znv2s9an3etvddeeze1NDe3KLdOE+jSaYks8JNABhfpCBlcBhdJIFIse1wGF0kgUix7XAYXSSBSLHtcBhdJIFIse1wGF0kgUix7XAYXSSBSLHtcBhdJIFIse1wkuG6RcmnEWlqL0T9+2NXUJP1+pXlrVK/lggNUgMW9Z09pyBC7vn6V3r6VPnyQvnyxCxO7tAZJLdAosxsXKg8cMLp3l0aMkMaNk8aPlyZNkoYNk/r1k75/lz5+NHDcX76UHjyQrl+3+/PnEnDpo4RWPDiAdO0qTZkiLVokzZkjDR9ev+l4JtAuX5bOnJFu3zavpc8CW1Nhu1wY/O2bedbq1dKCBVLv3o2Z+v69dOGCdOSIdO+e/SCEcQGtGHB4GSG1apW0Zo00cKCvaYTxqVPS4cPSp08G0PcNf/SWPlSB1qePtGGDtGKFDex/qNHgAyaU9ettUtm928bFxKGbFlyAtnmztHhxg3TqEF+6VOrfX9q+XXrzRuqWzrx0CXBILzZuLAZa4LpwobRlizRggOWD4bnzPQ04oOFt69ZJy5Y5q1xHd/Pm2btJptElQUsDDmiTJ0srVyZQuc4uCdtp02wmr1OkM1/zB8ev3LevTQZMCmU13r1pk00Y/JDOzR8cudrcudLEic6qRnTHimTWLBs2IsT/JuILDm8jR1uyJE3a8TdLOvrfjBmWaDuPdf7gZs+2NWdHhhT9fPp0afRo9xnWFxxQZs6sjrehDwWDqVMrDC6E6ZgxqFuthsdVNlRRjEV7r17VgoY2I0e6j3N+ocqUTy3NewHv8TOg1+DBruHqB87DwFR9sOBn3eoYrn7gKGlT6qZaW7VGSZ6EuJLgKCBSWKQeVrVGLRB4js3X4wDHVbVGJLx6ZRs9Trr5gUMhNmCqCI5l4OfPTsisGz9whCq7Tg8fuiro0tnTp9Lr1xX2OOBdveo6CLuAu3LFosFxI8fP47CQmZV9z7t3Xex16eTRI+n8efcNHH9w7DhdvOhis0snp09Ljx+7hil6+YILlhKuVcjnnj2Tzp1zh5YGHDkTu+vstJfd2GslVBNsFabxOColR4+Wm5oA7OzZJN6WxuN+9tr6e9y6JR08WM4MywknNqZJQxJ4WzpwTPsojNcdO1ZswJLs7t1rM+k/uSENPEpNe/YYQMI3deMd+/dLJ04k3cXHjDRjXABEXscyjLDZtcuy9/A/7zuz+L590qFDvw4eer+jpr+04HgR8PA+QnbrVpttU3gfk8HJkzamOq4Qali1+TM9OF6HIaQpN29K27ZJO3ZI9++3USTqQ219jXUynwuAhq7pjvO0R4LBmtA9ftxWF/PnS1xjx0qDBrUn0fYZY+aLF/YDXLsmrV1rR2H5Fku9d++Sj21BoWLB8VY8okcPq48BkCR11Cg7B8wO2dChdrSV41oUHymMAosTlzduSHfuSE+eSBMm2NYfffKZCYFhoaBWPLhgGEYGQwlbCgOkMEAFGN7JZ7wMLyU3I9UIz5cvtzMqQN2509ajCdOPoHa4lwcuaMAdg4PRgPq9GIqXAhmo/M0Z4uZm6dIl6cABW+IxhhbYqgGu1mDAcLXXGPzxRiowzNBMNnhiwdBQrZjD0+1BaOQZIRu8sCPIjfRfh2z1PK4Opf8P63q+m+g7xU1DiQwoq9sMLpJ8BpfBRRKIFMsel8FFEogUyx6XwUUSiBTLHpfBRRKIFMsel8FFEogUyx6XwUUSiBTLHpfBRRKIFPsP1Xl/7l+VUC8AAAAASUVORK5CYII="

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = IndexPage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _HomeTopBar = __webpack_require__(222);
	
	var _HomeTopBar2 = _interopRequireDefault(_HomeTopBar);
	
	var _BlogPosts = __webpack_require__(219);
	
	var _BlogPosts2 = _interopRequireDefault(_BlogPosts);
	
	var _Footer = __webpack_require__(53);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Branding = __webpack_require__(18);
	
	var _Branding2 = _interopRequireDefault(_Branding);
	
	var _Bubble = __webpack_require__(220);
	
	var _Bubble2 = _interopRequireDefault(_Bubble);
	
	var _MouseIcon = __webpack_require__(223);
	
	var _MouseIcon2 = _interopRequireDefault(_MouseIcon);
	
	var _ExtensionSelection = __webpack_require__(221);
	
	var _ExtensionSelection2 = _interopRequireDefault(_ExtensionSelection);
	
	var _Logo = __webpack_require__(211);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'HomeWrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'Homepage' },
	      _react2.default.createElement(
	        'div',
	        { className: 'IntroPane' },
	        _react2.default.createElement(_HomeTopBar2.default, null),
	        _react2.default.createElement(HomepageHero, null),
	        _react2.default.createElement(_MouseIcon2.default, null)
	      ),
	      _react2.default.createElement(AboutProductPane, null),
	      _react2.default.createElement(GettingStartedPane, null),
	      _react2.default.createElement(_BlogPosts2.default, null)
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	}
	
	function HomepageHero() {
	  return _react2.default.createElement(
	    _Bubble.BubbleLayerBoundary,
	    { className: 'HomepageHero' },
	    _react2.default.createElement(
	      'div',
	      { className: 'inner' },
	      _react2.default.createElement(_Branding2.default, { large: true, slogan: true }),
	      _react2.default.createElement(
	        'ul',
	        { className: 'links' },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#GetStarted', className: 'button dashing-icon expanded' },
	            _react2.default.createElement(
	              'span',
	              { className: 'text' },
	              'Get Started'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#GetStarted', className: 'button dashing-icon expanded' },
	            _react2.default.createElement('i', { className: 'icon icon-document' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'text' },
	              'Documentation'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://demo.mannequin.io',
	              className: 'button blue expanded'
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'text' },
	              'View Demo'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Bubble.BubbleLayer,
	      { travel: 5 },
	      _react2.default.createElement(_Bubble2.default, {
	        size: 130,
	        thickness: 20,
	        duration: 35,
	        blur: 2,
	        top: '67%',
	        left: '0',
	        bottom: '0',
	        opacity: 0.45
	      }),
	      _react2.default.createElement(_Bubble2.default, {
	        size: 38,
	        thickness: 11,
	        duration: 9,
	        blur: 2,
	        top: '70%',
	        right: '6%',
	        opacity: 0.45
	      })
	    ),
	    _react2.default.createElement(
	      _Bubble.BubbleLayer,
	      { travel: 15 },
	      _react2.default.createElement(_Bubble2.default, {
	        size: 85,
	        thickness: 13,
	        duration: 15,
	        blur: 6,
	        top: '60%',
	        left: '4%',
	        opacity: 0.25
	      }),
	      _react2.default.createElement(_Bubble2.default, {
	        size: 75,
	        thickness: 13,
	        duration: 10,
	        blur: 6,
	        top: '30%',
	        right: '13%',
	        opacity: 0.25
	      })
	    ),
	    _react2.default.createElement(
	      _Bubble.BubbleLayer,
	      { travel: 30 },
	      _react2.default.createElement(_Bubble2.default, {
	        size: 35,
	        thickness: 8,
	        duration: 9,
	        blur: 4,
	        top: '15%',
	        left: '15%',
	        opacity: 0.07
	      }),
	      _react2.default.createElement(
	        _Bubble.BubbleCluster,
	        { duration: 15, left: '40%', top: '72%' },
	        _react2.default.createElement(_Bubble2.default, { size: 30, thickness: 10, blur: 5, opacity: 0.07 }),
	        _react2.default.createElement(_Bubble2.default, { size: 40, thickness: 13, blur: 5, opacity: 0.07 })
	      )
	    )
	  );
	}
	
	function AboutProductPane() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'AboutProductPane' },
	    _react2.default.createElement(
	      _Bubble.BubbleLayerBoundary,
	      { className: 'inner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'note' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Introduction'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Mannequin bridges the gap between design and development by rendering templates in an isolated environment.'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/about', className: 'button dashing-icon' },
	          _react2.default.createElement('i', { className: 'icon icon-right' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'text' },
	            'Explore'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'shot-casing' },
	        _react2.default.createElement('div', { className: 'shot' })
	      )
	    )
	  );
	}
	
	function GettingStartedPane() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'GetStartedPane' },
	    _react2.default.createElement(_Logo2.default, { className: 'logo' }),
	    _react2.default.createElement(
	      'h2',
	      { id: 'GetStarted' },
	      'Get Started'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'ChooseExtensionStep Step' },
	      _react2.default.createElement(
	        'div',
	        { className: 'intro' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'What kind of templates are you using?'
	        )
	      ),
	      _react2.default.createElement(_ExtensionSelection2.default, null)
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-e9ee344f3d766794996b.js